import { SiteConfigHelper } from "@shared/utils/site-config.helper";
import { UserProfile } from "@shared/classes/user-profile";
import { CommonFieldName } from "@shared/constants";
import { DateTimeFormatStrings, SortType } from "../enums";
import { Utilities } from "../utils/utilities";

export class CommonDataStateModel {
  profileMe: UserProfile;
  isCommonDataLoaded: boolean;
}

export interface CommonSearchContext {
  searchForm: CommonSearchForm;
  needResetForm: boolean;
}

export interface CommonSearchForm {
  model: CommonSearchCriteriaModel;
  dirty: boolean;
  status: string;
  errors: any;
}

export interface CommonSearchCriteriaModel {
  searchCriteria: CommonSearchCriteria[]
}

export interface CommonSearchCriteria {
  searchBy: string;
  searchValue: number | number[] | string | string[];
  searchValueStart: string;
  searchValueEnd: string;
  isSearchByDisabled?: boolean;
}

export interface CommonPageFilterSetting {
  functionName: string; // NgxsActionName
  sortBy: string; // sort by column name
  sortDirection: string; // sort by direction; asc or desc
  pageSize: number; // how many data in each page
  pageIndex: number; // page index; start from 0
}

export interface CommonPageSetting {
  functionName: string; // NgxsActionName
  pageSearchInitialized: boolean; // when page first initialized, automatically do the search
}

export interface CommonEditContext<T> {
  editForm: CommonEditForm<T>;
}

export interface CommonEditForm<T> {
  model: T;
  dirty: boolean;
  status: string;
  errors: any;
}

export const CreateCommonSearchContext = () => {
  return {
    searchForm: {
      model: {
        searchCriteria: [GenerateDefaultCommonSearchCriteria()]
      } as CommonSearchCriteriaModel,
      dirty: false,
      status: null as any,
      errors: null as any,
    },
    needResetForm: true
  } as CommonSearchContext;
}

export const CreateCommonPageFilterSetting = (functionName: string) => {
  return {
    functionName: functionName,
    sortBy: '',
    sortDirection: '',
    pageIndex: 0,
    pageSize: SiteConfigHelper.GetDefaultPageSize()
  } as CommonPageFilterSetting;
}

export const CreatePageFilterSettingWithLstChangeOnSort = (functionName: string) => {
  return {
    functionName: functionName,
    sortBy: CommonFieldName.lastModified_On,
    sortDirection: SortType.Desc,
    pageIndex: 0,
    pageSize: SiteConfigHelper.GetDefaultPageSize()
  } as CommonPageFilterSetting;
}

export const GenerateDefaultCommonSearchCriteria = () => {
  return {
    searchBy: '',
    searchValue: '',
    searchValueStart: '',
    searchValueEnd: ''
  } as CommonSearchCriteria;
}

export const GenerateLastModifySearchCriteria = (apexId: string) => {
  var searchCriteriaList: CommonSearchCriteria[] = [];
  searchCriteriaList.push({
    searchBy: CommonFieldName.lastModified_By,
    searchValue: apexId,
    searchValueStart: '',
    searchValueEnd: ''
  } as CommonSearchCriteria);

  var currentDate = new Date(new Date().toDateString()).toISOString();
  searchCriteriaList.push({
    searchBy: CommonFieldName.lastModified_On,
    searchValue: '',
    searchValueStart: currentDate,
    searchValueEnd: currentDate
  } as CommonSearchCriteria);

  searchCriteriaList.push({
    searchBy: '',
    searchValue: '',
    searchValueStart: '',
    searchValueEnd: ''
  } as CommonSearchCriteria);

  return searchCriteriaList;
}
